import React from "react";
import { Card } from "react-bootstrap";
import { useInView } from "react-intersection-observer";

import { LearnMore } from "../learn-more";
import styles from "./index.module.scss";
import clsx from "clsx";

export interface HowWeHelpItemProps {
  title: string;
  description: string;
  image: string;
  link: string;
}

export function HowWeHelpItem(props: HowWeHelpItemProps) {
  const { ref, inView } = useInView({});
  const { title, description, image, link } = props;

  return (
    <Card
      className={clsx([
        styles.card,
        "animate__animated",
        "animate__slow",
        { animate__fadeIn: inView }
      ])}
      ref={ref}
    >
      <Card.Img variant="top" src={image} className={styles.image} />
      <Card.Body>
        <Card.Title className={styles.title}>{title}</Card.Title>
        <Card.Text>
          <div className={styles.description}>{description}</div>
          <div className={styles.link}>
            <LearnMore text="了解详情" link={link} />
          </div>
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
